function r(r,e){return Object.defineProperty?Object.defineProperty(r,"raw",{value:e}):r.raw=e,r}"function"==typeof SuppressedError&&SuppressedError;export{r as __makeTemplateObject};
